var render = function render(){var _vm=this,_c=_vm._self._c;return _c('block-tile',{attrs:{"asset":_vm.asset,"asset-type":_vm.type,"asset-completed":_vm.asset.completedState(_vm.assetState),"featured-image":_vm.displayAttachment,"metadata":_vm.metadata,"metadata-icon-name":_vm.icon,"source":_vm.source,"state":_vm.assetState,"title":_vm.title},on:{"tile-clicked":function($event){return _vm.$emit('tile-clicked')}}})
}
var staticRenderFns = []

export { render, staticRenderFns }